module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-routes/master-routes.component.scss
// module id = ./src/app/master/master-routes/master-routes.component.scss
// module chunks = main